import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "../components/Login/Login"
import ContentDashboard from "../components/Dashboard";
import ProfileDetails from "../components/ProfileDetails/ProfileDetails";
import ResetPasswordForm from "../components/ResetPassword/ResetPasswordForm";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoutes";
const AppRoutes = () => {
  return (
    <Router>
      <Routes>
      <Route path="/" element={<Navigate to="/content-analytics" />}/>
      <Route path="/signin" element={<PublicRoute element={<Login />} />}
      />
      <Route
          path="/content-analytics"
          element={<ProtectedRoute element={<ContentDashboard />} />}
        />
      <Route
          path="/profile-details"
          element={<ProtectedRoute element={<ProfileDetails />} />}
        />
      <Route path = "/forgot-password" element = {<ResetPasswordForm/>}/>
      </Routes>
    </Router>
  );
};
export default AppRoutes;
